export function smartBack(navigate, fallback = '/') {
  try {
    const idx = window?.history?.state?.idx
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1)
      return
    }
  } catch {}

  navigate(fallback || '/')
}
